$(function () {
    var data = {
        products: window.products,
    };

    window.addEventListener('load', function () {
        var elements = document.getElementsByClassName('shop-content');
        if (elements.length === 0) {
            return;
        }

        var width = elements[0].clientWidth;

        var dropDowns = document.getElementsByClassName('shop-nav-dropdown');
        for (var i = 0; i< dropDowns.length; i++) {
            dropDowns[i].style.width = width + 'px';
        }
    });

    function shopCart(form)
    {
        var dataForm = Object.fromEntries(new FormData(form));

        var items = JSON.stringify({
            product_id: dataForm.product_id,
            count: dataForm.product_count,
            options: JSON.parse(dataForm.product_options),
        });

        var data = {
            product_group_id: 10,
            name: dataForm.product_name,
            items: items,
        };
        $.post('/shopcart/items', data, function (response) {
            if (response.hasOwnProperty('error')) {
                alert(response.error);
            } else {
                $(form).addClass('is-hidden');
                $(form).parent().find('.js-shopcart-btn').removeClass('is-hidden');
            }
        });
    }

    function getProduct(productID) {
        var product = null;
        data.products.forEach(function (item) {
            if (parseInt(item.id) !== parseInt(productID)) {
                return;
            }

            product = item;
        });

        return product;
    }

    function getCost(productID, count) {
        var maxCost = getMaxCost(productID, count);
        var cost = getActualCost(productID, count, maxCost);

        return cost.toFixed(2);
    }

    function getMaxCost(productID, count) {
        var product = getProduct(productID);

        var cost = parseFloat(product.cost);

        var minPriceGroupCost = 0;
        product.prices.forEach(function (price) {
            if (parseFloat(price.priceGroup.cost) > minPriceGroupCost) {
                return;
            }

            minPriceGroupCost = parseFloat(price.priceGroup.cost);
            cost = parseFloat(price.cost);
        });

        return cost * count;
    }

    function getActualCost(productID, count, productCost) {
        var product = getProduct(productID);

        var cost = parseFloat(product.cost);

        var minPriceGroupCost = 0;
        product.prices.forEach(function (price) {
            if (
                parseFloat(price.priceGroup.cost) >= minPriceGroupCost
                && parseFloat(price.priceGroup.cost) <= productCost
            ) {
                minPriceGroupCost = parseFloat(price.priceGroup.cost);
                cost = parseFloat(price.cost);
            }
        });

        return (cost * count);
    }

    function parseQuery(queryString) {
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }

    function encodeQuery(query) {
        var string = '';
        for (var key in query) {
            if (string.length === 0) {
                string = '?';
            } else {
                string += '&';
            }

            string += key + '=' + query[key];
        }

        return string;
    }

    // Обработка выбора опций продукта
    function initProductOptions() {
        var optionRadios = document.querySelectorAll('.js-product-option-radio');
        var optionsInput = document.querySelector('.js-product-options');
        
        // Функция для сбора всех выбранных опций
        function updateSelectedOptions() {
            var selectedOptions = {};
            
            optionRadios.forEach(function(radio) {
                if (radio.checked) {
                    var optionId = radio.getAttribute('data-option-id');

                    selectedOptions[optionId] = {
                        option_id: optionId,
                        value_id: radio.value,
                    };
                }
            });
            
            if (optionsInput) {
                debugger;
                optionsInput.value = JSON.stringify(selectedOptions);
            }
            
            return selectedOptions;
        }
        
        // Установить начальные значения выбранных опций
        updateSelectedOptions();
        
        // Обработчик изменения выбора опции
        optionRadios.forEach(function(radio) {
            radio.addEventListener('change', function() {
                updateSelectedOptions();
            });
        });
    }

    $(document).ready(function () {
        $(document).on('submit', '.js-shop-product-form', function (e) {
            e.preventDefault();
            shopCart(this);
        });

        $(document).on('change', '.js-change-product-count', function (e) {
            var form = $(this).parents('form')[0];
            var count = $(this).val();
            var productID = $(form).find('input[name="product_id"]').val();
            var cost = getCost(productID, count);
            $(form).find('.js-product-cost').text(cost);
        });

        $(document).on('change', '.js-toggle-available', function () {
            var query = parseQuery(window.location.search);
            if ($(this).prop('checked')) {
                query.show_available = 1;
            } else {
                query.show_available = 0;
            }

            window.location.search = encodeQuery(query);
        });
        
        // Инициализация обработки опций продукта
        initProductOptions();
    });
})